import React, { PureComponent } from 'react';
import { message as AntMessage } from 'antd';
import { forEach } from 'lodash';
import ExportJsonExcel from 'js-export-excel';
/**
 * 可视化页面json转化excel导出页面功能按钮
 */
export class PageJsExportExcelButton extends PureComponent<any, any> {
    exportExcel = () => {
        let row = this.props.row.config;
        if (row) {
            row = JSON.parse(row);
            if (row.components) {
                let productArr = [];
                forEach(row.components, (c) => {
                    if (
                        c.component &&
                        (c.component === 'pointProducts' ||
                            c.component === 'products' ||
                            c.component === 'pointProductCard' ||
                            c.component === 'productCard') &&
                        (c.showStyle || c.showStyle === '0') &&
                        c.entry
                    ) {
                        productArr = [...productArr, ...c.entry];
                    }
                });
                if (!productArr.length) {
                    AntMessage.info('没有要导出的商品');
                } else {
                    // 直接导出文件
                    let option: any = {}; //option代表的就是excel文件
                    option.fileName = this.props.row.name; //excel文件名称
                    option.datas = [
                        {
                            sheetData: productArr, //excel文件中的数据源
                            sheetName: 'Sheet1', //excel文件中sheet页名称
                            sheetFilter: ['sku', 'spu', 'showName', 'price', 'pointPrice', 'type'], //excel文件中需显示的列数据
                            sheetHeader: [
                                'SKU编码',
                                'SPU',
                                '商品名称',
                                '商品价格',
                                '甄币',
                                '商品类型',
                            ], //excel文件中每列的表头名称
                        },
                    ];
                    let toExcel = new ExportJsonExcel(option); //生成excel文件
                    toExcel.saveExcel(); //下载excel文件
                }
            } else {
                AntMessage.info('此页面还没有组件，没有要导出的商品');
            }
        } else {
            AntMessage.info('此页面还没有进行装饰，没有要导出的商品');
        }
    };
    render() {
        return (
            <a className="table-action-column-item" onClick={this.exportExcel}>
                导出
            </a>
        );
    }
}
